import React, {Component} from "react"
import _ from 'lodash'

class GraphingCalculator extends Component {
    constructor(props){
        super(props);
        this.state = {
            expressions: props.value.expressions,
            gridBounds: props.value.gridBounds,
            lock: props.value.lock
        };
        this.calcId = props.name;
    }

    componentDidMount() {
      if (!document.getElementById("desmos-script")) {
        const script = document.createElement('script');
        script.src = "https://www.desmos.com/api/v1.6/calculator.js?apiKey=8e37d405f18147c9a132f5286e1f51f5";
        script.async = true;
        script.id = "desmos-script";
        document.body.appendChild(script);
        script.onload = () => {
          this.generateGraph();
        };
      } else {
        if (!window.Desmos) {
          document.getElementById("desmos-script").addEventListener("load", () => this.generateGraph());
        } else {
          this.generateGraph();
        }
      }
    }

    componentDidUpdate(prevProps) {
      if (!_.isEqual(prevProps.value, this.props.value)) {
        this.setState({
          expressions: this.props.value.expressions,
          gridBounds: this.props.value.gridBounds,
      }, () => this.generateGraph());
      }
    }

    generateGraph() {
      document.getElementById(this.calcId).innerHTML = '';
      const elt = document.getElementById(this.calcId);
      const calculator = window.Desmos.GraphingCalculator(elt,
        {
          expressions: false,
          settingsMenu: false,
          lockViewport: this.state.lock,
          showXAxis: this.props.removeGrid ? false : true,
          showYAxis: this.props.removeGrid ? false : true,
          showGrid: this.props.removeGrid ? false : true,
          xAxisStep: this.props.xStep ? this.props.xStep : 0,
          yAxisStep: this.props.yStep ? this.props.yStep : 0,
        });
      this.calculator = calculator;
      this.addExpressionsToCalculator();
    }

    setExpression(expressions) {
        if (this.calculator) {
            this.calculator.setExpression(expressions);
        }
    }

    addExpressionsToCalculator() {
        if (!this.calculator) {
            return;
        }
        this.state.expressions.forEach((expression) => {
            this.calculator.setExpression({
              ...expression.id && {id: expression.id},
              ...expression.lineWidth && {lineWidth: expression.lineWidth},
              ...expression.lines && {lines: true},
              ...expression.noPoints && {points: false},
              ...expression.label && {label: expression.label},
              ...expression.showLabel && {showLabel: true},
              ...expression.style === "dashed" && {lineStyle: window.Desmos.Styles.DASHED},
              latex: expression.exp,
              dragMode: window.Desmos.DragModes.NONE,
              color: (expression.color !== undefined) ? expression.color : "#000000",
              fillOpacity: (expression.fillOpacity !== undefined) ? expression.fillOpacity : 0.4, // 0.4 is default
            });
        });
        this.calculator.setMathBounds({
            left: this.state.gridBounds.left,
            right: this.state.gridBounds.right,
            top: this.state.gridBounds.top,
            bottom: this.state.gridBounds.bottom,
        });
    }

    render() {
        return (
          <div 
            id={this.calcId} 
            style={{ width: "inherit",  height: "inherit", maxWidth: "inherit", maxHeight: "inherit" }} 
            onPointerUp={(e) => this.props.onMouseDown ? this.props.onMouseDown(e) : {}}
          />
        );
    }
}

export default GraphingCalculator;
